import { render, staticRenderFns } from "./TChipGroup.vue?vue&type=template&id=be2ada40&"
import script from "./TChipGroup.vue?vue&type=script&lang=js&"
export * from "./TChipGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
installComponents(component, {VChipGroup})
